// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import classnames from 'classnames'


import PropTypes from 'prop-types'


import 'styles/components/shared/ToolTipOnHover.styl'

const ToolTipOnHover = React.createClass({
  propTypes: {
    toolTip: PropTypes.node.isRequired,
    debounceHoverTime: PropTypes.number
  },

  getInitialState() { return {} },

  renderToolTip() {
    return (
      <div className={classnames('tool-tip', this.props.variant)}>
        {this.props.toolTip}
      </div>
    )
  },

  onMouseOver() {
    if (this.debouncedSetShowTooltip) {
      this.debouncedSetShowTooltip.cancel()
    }

    if (this.props.debounceHoverTime) {
      this.debouncedSetShowTooltip = _.debounce((() => this.setState({ showTooltip: true })), this.props.debounceHoverTime)
      return this.debouncedSetShowTooltip()
    } else {
      return this.setState({ showTooltip: true })
    }
  },

  onMouseOut() {
    if (this.debouncedSetShowTooltip != null) {
      this.debouncedSetShowTooltip.cancel()
    }
    return this.setState({ showTooltip: false })
  },

  render() {
    return (
      <div
        className={classnames('ToolTipOnHover', this.props.className)}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}>
        {this.props.children}
        {this.state.showTooltip || this.props.showTooltip ? this.renderToolTip() : undefined}
      </div>
    )
  }
})

export default ToolTipOnHover



// WEBPACK FOOTER //
// ./src/scripts/components/shared/ToolTipOnHover.js